module.exports = __webpack_public_path__ + "static/media/qrcode.78b9dcb5.svg";